import { freeUserUpgradeStep } from '../utils';

export const donationsCreateTour = {
  tourKey: 'donations_create',
  conditions: {
    orgTypes: ['business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      title: 'tours.donations-create.welcome.title',
      content: 'tours.donations-create.welcome.content',
      placement: 'center',
    },
    freeUserUpgradeStep,
  ],
};
